var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5.5C3.41848 5.5 3.10054 5.6317 2.86612 5.86612C2.6317 6.10054 2.5 6.41848 2.5 6.75V13C2.5 13.3315 2.6317 13.6495 2.86612 13.8839C3.10054 14.1183 3.41848 14.25 3.75 14.25H11.25C11.5815 14.25 11.8995 14.1183 12.1339 13.8839C12.3683 13.6495 12.5 13.3315 12.5 13V6.75C12.5 6.41848 12.3683 6.10054 12.1339 5.86612C11.8995 5.6317 11.5815 5.5 11.25 5.5H5.625V4.25C5.625 3.75272 5.82254 3.27581 6.17417 2.92417C6.52581 2.57254 7.00272 2.375 7.5 2.375C7.99728 2.375 8.47419 2.57254 8.82583 2.92417C9.17746 3.27581 9.375 3.75272 9.375 4.25H10.625C10.625 3.4212 10.2958 2.62634 9.70971 2.04029C9.12366 1.45424 8.3288 1.125 7.5 1.125C7.08962 1.125 6.68326 1.20583 6.30411 1.36288C5.92497 1.51992 5.58047 1.75011 5.29029 2.04029C5.00011 2.33047 4.76992 2.67497 4.61288 3.05411C4.45583 3.43326 4.375 3.83962 4.375 4.25V5.5H3.75ZM7.5 11.125C7.16848 11.125 6.85054 10.9933 6.61612 10.7589C6.3817 10.5245 6.25 10.2065 6.25 9.875C6.25 9.54348 6.3817 9.22554 6.61612 8.99112C6.85054 8.7567 7.16848 8.625 7.5 8.625C7.83152 8.625 8.14946 8.7567 8.38388 8.99112C8.6183 9.22554 8.75 9.54348 8.75 9.875C8.75 10.2065 8.6183 10.5245 8.38388 10.7589C8.14946 10.9933 7.83152 11.125 7.5 11.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlock);
export default __webpack_public_path__ + "static/media/ic-unlock.2186ed69979a940a889c130cd4086209.svg";
export { ForwardRef as ReactComponent };